// extracted by mini-css-extract-plugin
var _1 = "KyYVXqoiRavalEwol0zU";
var _2 = "P5aezGEM489aTZNOb6Ty";
var _3 = "Hgfh2FliVS1yi7miAL_Y";
var _4 = "Q7LSo1FzVNmNyfYGdAFT";
var _5 = "Gar1RrZado2doi9wliz6";
var _6 = "nZU__lXusrjnqdrZrQS6";
var _7 = "tOHl8RiATOCYfjpCG7GC";
var _8 = "_F0g3Vebbf7ZbSOAmMkx";
var _9 = "m9oi68HZFtzonBg1QYL3";
export { _1 as "alt", _2 as "alts", _3 as "alts_list", _4 as "input", _5 as "oauth_btn", _6 as "oauth_err", _7 as "or", _8 as "reset_row", _9 as "separator" }
